import React from 'react';

import air_freight_icon from "../../assets/img/services/freight_forwarding/air_freight.png";
import sea_freight_icon from "../../assets/img/services/freight_forwarding/sea_freight.png";
import road_freight_icon from "../../assets/img/services/freight_forwarding/road_freight.png";
import custom_clearance_bg from "../../assets/img/services/freight_forwarding/custom_clearance_bg.jpg";

import BigTitle from "../BigTitle";
import {Helmet} from "react-helmet";
import {FormattedMessage} from "react-intl";


const freight_forwarding = [
    {
        title: <FormattedMessage id={"freight_forwarding.0.title"}/>,
        text: <FormattedMessage id={"freight_forwarding.0.text"} />,
        icon: air_freight_icon
    }, {
        title: <FormattedMessage id={"freight_forwarding.1.title"}/>,
        text: <FormattedMessage id={"freight_forwarding.1.text"}/>,
        icon: road_freight_icon
    }, {
        title: <FormattedMessage id={"freight_forwarding.2.title"}/>,
        text: <FormattedMessage id={"freight_forwarding.2.text"}/>,
        icon: sea_freight_icon
    }
];


const meta = require("../../translations/meta.json");


export default class FreightForwarding extends React.Component {

    render() {
        return <div className={"freight_forwarding"} dir={this.props.lang === "ar" ? "rtl" : "ltr"}>
            {!this.props.no_meta && <Helmet>
                <title>{meta[this.props.lang].main_services.title}</title>
                <meta name="description"
                      content={meta[this.props.lang].main_services.description}
                />
            </Helmet>}

            <div className={"r "}>
                <div className={"c-1-1"}>

                    <BigTitle title={<FormattedMessage id={"freight_forwarding.ff.title"}/>} isYellow/>

                    <div className={"r ff-description"}>
                        <div className={"c-1-1"}>
                            <p><FormattedMessage id={"freight_forwarding.ff.p1"}/></p>
                            <p><FormattedMessage id={"freight_forwarding.ff.p2"}/></p>
                            <p><FormattedMessage id={"freight_forwarding.ff.p3"}/></p>
                        </div>
                    </div>
                    <ul className={"r"}>
                        {freight_forwarding.map((item, i) => {
                            return <li className={"c-1-3"} key={i}>
                                <div className={"li-content"}>
                                    <h3 className={"r black"}>{item.title}</h3>
                                    <div dir="ltr">
                                        <img src={item.icon} alt={item.title}/>
                                        <span>{item.text}</span></div>
                                </div>
                            </li>
                        })
                        }
                    </ul>

                </div>

                <div className={"r "}>
                    <div className={"c-1-1"}>
                        <div className={"customs_clearance"}>
                            <div className={"customs_clearance_guy"}
                                 style={{backgroundImage: "url(" + custom_clearance_bg + ")"}}>

                                <BigTitle title={<FormattedMessage id={"freight_forwarding.cc.title"}/>}/>
                            </div>

                            <div className={"r customs_clearance_description"} align="justified">
                                <div className={"c-1-1"} align="justified">
                                    <p><FormattedMessage id={"freight_forwarding.cc.p1"}/></p>
                                    <p><FormattedMessage id={"freight_forwarding.cc.p2"}/></p>
                                    <p><FormattedMessage id={"freight_forwarding.cc.p3"}/></p>
                                    <p><FormattedMessage id={"freight_forwarding.cc.p4"}/></p>
                                    <p><FormattedMessage id={"freight_forwarding.cc.p5"}/></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/pages/FreightForwarding.js